import React from "react";

import FileUploadDetail from "../component/FileUploadDetail";

const FileUploadDetailContainer = () => (<FileUploadDetail />)

export default FileUploadDetailContainer; 
